<template>
  <ul :class="menuClass" @click.stop="noop">
    <tree-menu-item
      v-for="item in effectiveItems"
      :key="item.id"
      :item="item"
      :parent-level="level"
      :expanded-items="expandedItems"
      :selected="item.selected && isSelectedHighlight"
      :variant="variant"
      :ctrl-click="ctrlClick"
      @item-expanded="handleItemExpanded"
      @item-highlighted="handleItemHighlighted"
      @item-toggled="itemToggled"
      @item-clicked="itemClicked"
    >
      <template #accent="{ itemForSlot }">
        <slot name="accent" :item-for-slot="itemForSlot" />
      </template>
      <template #itemSlot="{ itemForSlot }">
        <slot name="itemSlot" :item-for-slot="itemForSlot" />
      </template>
    </tree-menu-item>
  </ul>
</template>

<script>
import TreeMenuItem from './tree-menu-item'

export default {
  name: 'TreeMenu',
  components: { TreeMenuItem },
  props: {
    level: {
      type: Number,
      default: 1,
    },
    items: {
      type: Array,
      required: true,
    },
    expandedItems: {
      type: Object,
      default: () => ({}),
    },
    seemless: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'default',
    },
    ctrlClick: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['item-clicked', 'item-expanded', 'item-highlighted', 'item-toggled'],
  computed: {
    effectiveItems() {
      return this.items.filter((item) => item)
    },
    isRoot() {
      return this.level === 1
    },
    isTopSubmenu() {
      return this.level === 2
    },
    menuClass() {
      if (this.isRoot && !this.seemless) {
        return { 'sf-tree-menu': true, 'tw-m-0': true, 'tw-list-none': true }
      }

      return {
        'sf-tree-menu__group-content': true,
        'sf-tree-menu__group-content--top-level': this.isTopSubmenu,
        'tw-m-0': true,
        'tw-list-none': true,
      }
    },
    isSelectedHighlight() {
      return this.variant === 'default'
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    noop: () => {},
    handleItemExpanded(itemId) {
      this.$emit('item-expanded', itemId)
    },
    handleItemHighlighted(itemId) {
      this.$emit('item-highlighted', itemId)
    },
    itemClicked: function (data) {
      this.$emit('item-clicked', data)
    },
    itemToggled(itemId) {
      this.$emit('item-toggled', itemId) // bubble the event
    },
  },
}
</script>
